import React from 'react';
import { Navigate } from 'react-router-dom';
import CalendarioPeritumWidget from './CalendarioPeritumWidget';
import MisReunionesHoyWidget from './MisReunionesHoyWidget';
import RequireCalendarSetup from './RequireCalendarSetup';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <RequireCalendarSetup>
      {children}
      <CalendarioPeritumWidget />
      <MisReunionesHoyWidget />
    </RequireCalendarSetup>
  );
};

export default ProtectedRoute;
